import { DialogActions, DialogContent, Button} from '@mui/material'
import { CustomTextField } from 'Components/CustomTextField'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
export const ImmobilierImgUploadForm = ({
  setFiles,
  handleClose,
  upload_immobilier_picture
  
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      picture: '',
    },
  })
  const [ picerror, setPicerror ] = useState(false)
  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }
    delete payload.picture
    upload_immobilier_picture()
    reset({picture: '',})   
  }
  return (
      <form onSubmit={handleSubmit(onSubmit)}>
      <DialogContent>        
        <CustomTextField
          label="Picture"
          type="file"
          fullWidth          
          inputProps={{
            accept:"image/*",multiple:false
          }}
          multiple          
          register={{
            ...register('picture', {             
              onChange: (e) => { if(e.target.files.length > 5) {
                setPicerror(true)
                setError("picture",{type:'custom',message:'Picture cannot be more the 5.'})
              }else{
                setFiles(e.target.files)
                setPicerror(false)
                clearErrors('picture')}
              }             
            }),
          }}
          error={(errors.picture && true)}
          helperText={errors.picture?.message || "Picture cannot be more the 5."}
        />         
      </DialogContent>
      <DialogActions>
        <Button type="submit" disabled={picerror?picerror:false}>Valider</Button>
        <Button onClick={()=>handleClose()}>Annuler</Button>
      </DialogActions>   
    </form>
  )
}
